import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import 'font-awesome/css/font-awesome.min.css';

// Components
import Header from './components/Header';
import Navbar from './components/Navbar';

// Pages
import Home from './pages/Home';
import Government from './pages/Government';
import PrimeMinister from './pages/PrimeMinister';
import Bei from './pages/Bei';
import Media from './pages/Media';
import Transparency from './pages/Transparency';
import Meetings from './pages/Meetings';
import Contacts from './pages/Contacts';
import VisaCheck from './pages/VisaCheck';
import Messages from './pages/Messages';
import Live from './pages/Live';
import MinisterDetails from './pages/MinisterDetails'; // (Path adjust karein agar file kisi folder mein hai)
import VisaPage from './pages/VisaPage';
import Admin from './pages/Admin'; // <--- STEP 1: Yahan Real Admin File Import ki


const Placeholder = ({ title }) => <div className="container mt-5"><h2>{title} Page</h2></div>;

function App() {
  return (
    <Router>
      <div className="App bg-white min-vh-100 d-flex flex-column">
        <Header />
        <Navbar />
        
        <main className="flex-grow-1">
            <Routes>
              {/* Main Home Page */}
              <Route path="/" element={<Home />} />
              
              {/* Government Page */}
              <Route path="/government" element={<Government />} />
              <Route path="/government/minister/:id" element={<MinisterDetails />} />
              <Route path="/prime-minister" element={<PrimeMinister />} />
              <Route path="/bei" element={<Bei />} />
              <Route path="/media" element={<Media />} />
              <Route path="/transparency" element={<Transparency />} />
              <Route path="/meetings" element={<Meetings />} />
              <Route path="/contacts" element={<Contacts />} />
               <Route path="/messages" element={<Messages />} />
                 <Route path="/live" element={<Live />} />
              
              {/* Visa Check Page */}
              <Route path="/visa-check" element={<VisaCheck />} />
              <Route path="/visa-list" element={<VisaPage />} />
              {/* STEP 2: Yahan Placeholder hata kar <Admin /> lagaya */}
              <Route path="/admin" element={<Admin />} />
              
            </Routes>
        </main>
        
        {/* Footer */}
        <footer className="bg-light text-center py-4 border-top mt-5">
           <div className="container">
               <div className="d-flex align-items-center justify-content-center gap-2 mb-2">
                   <img src="/images/logo.svg" width="30" alt="logo"/>
                   <small className="text-primary fw-bold">GOVERNMENT OF REPUBLIC OF MOLDOVA</small>
               </div>
               <div className="d-flex mt-3" style={{height:'10px'}}>
                   <div style={{flex:1, backgroundColor:'#003366'}}></div>
                   <div style={{flex:1, backgroundColor:'#FFD700'}}></div>
                   <div style={{flex:1, backgroundColor:'#CC0000'}}></div>
               </div>
           </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;